import { EVENTS, subscribe } from 'ia-util-pubsub'

if (!customElements.get('ia-product-buy')) {
  class IaProductBuy extends HTMLElement {
    constructor () {
      super()
      this.form = this.querySelector('form')
      this.submitButton = this.querySelector('button[type="submit"]')
      this.submitButtonTextSpan = this.submitButton?.querySelector('span:not(.button__divider):not(.button__price-compare):not(.button__price)')
      this.textAddToCart = this.submitButton?.dataset.addToCartText || 'Add to Cart'
      this.textSoldOut = this.submitButton?.dataset.soldOutText || 'Sold Out'
      this.textUnavailable = this.submitButton?.dataset.unavailableText || 'Unavailable'
      this.cart = document.querySelector('ia-cart')
      this.variantInput = this.querySelector('input[name="id"]')
      this.quantityInput = this.querySelector('input[name="quantity"]')
      this.planInput = this.querySelector('input[name="selling_plan"]')
      this.parentBlock =  this.parentElement.closest('ia-product-card') ||this.parentElement.closest('ia-main-product')

      this.unsubscribeVariantChange = subscribe(EVENTS.variantChange, this.handleVariantChange.bind(this))
      this.unsubscribeVariantLoading = subscribe(EVENTS.variantLoading, this.handleVariantLoading.bind(this))
      this.unsubscribePlanChange = subscribe(EVENTS.planChange, this.subscriptionChange.bind(this))
      this.unsubscribeCadenceChange = subscribe(EVENTS.cadenceChange, this.subscriptionChange.bind(this))
    
    }

    async connectedCallback() {
      if (this.form) {
        this.form.addEventListener('submit', this.onSubmit.bind(this))
      }
    }

    disconnectedCallback() {
      if (this.unsubscribeVariantChange) {
        this.unsubscribeVariantChange()
      }
      if (this.unsubscribeVariantLoading) {
        this.unsubscribeVariantLoading()
      }
      if (this.unsubscribePlanChange) {
        this.unsubscribePlanChange()
      }
    }

    get sectionId() {
      return this.getAttribute('section-id')
    }

    get productId() {
      return this.getAttribute('product-id')
    }

    handleVariantLoading(event) {
      const { productId, sectionId, loading } = event.detail
      if (productId == this.productId && sectionId == this.sectionId && this.submitButton) {
        if (loading) {
          this.submitButton.classList.add('loading')
        } else {
          this.submitButton.classList.remove('loading')
        }
      }
    }

    handleVariantChange(event) {
      const { productId, sectionId, variant } = event.detail
      if (this.variantInput && productId == this.productId && sectionId == this.sectionId) {
        if (variant) {
          this.variantInput.value = variant.id
          if (this.submitButtonTextSpan) this.submitButtonTextSpan.textContent = variant.available ? this.textAddToCart : this.textSoldOut
        } else {
          this.variantInput.value = ''
          if (this.submitButtonTextSpan) this.submitButtonTextSpan.textContent = this.textUnavailable
        }
      }
    }


    async onSubmit (event) {
      event.preventDefault()

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return

      this.handleErrorMessage()
      this.submitButton.classList.add('adding')

      try {
        const ts = window.iaCartAPI?.getTimestamp()
        this.form.querySelectorAll('[data-property-ts]').forEach((input) => {
          input.value = ts
        })

        const formData = new FormData(this.form)

        if (this.parentBlock) {
          const planId = this.parentBlock.querySelector('[cadence="subscription"]')?.querySelector('[data-selling-plan-select]')?.value
          if (this.planInput && planId) {
            formData.append('selling_plan', planId)
          }
        }
        const response = await window.iaCartAPI?.addToCart(formData)
        this.handleSuccess(response)
      } catch (error) {
        this.handleError(error)
      } finally {
        this.submitButton.classList.remove('adding')
        this.submitButton.removeAttribute('aria-disabled')
      }
    }

    handleSuccess (data) {
      this.cart?.open(data)
    }

    handleError (error) {
      this.handleErrorMessage(error?.description || error.message || 'An error occurred')
    }

    handleErrorMessage (message = false) {
      const errorElement = this.querySelector('[data-error-message]')
      if (!errorElement) return

      errorElement.classList.toggle('hidden', !message)
      if (message) {
        errorElement.textContent = message
      }
    }

    subscriptionChange(event) {
      const { productId, sectionId, cadence, plan } = event.detail
      if (productId == this.productId && sectionId == this.sectionId) {
        console.log('[PRODUCT FORM] subscriptionChange, productId:', productId, 'sectionId:', sectionId, 'event:', event);
        this.planInput.value = ''
        if (cadence == 'subscription' && plan && plan.id) {
          console.log('this.planInput', this.planInput);
          this.planInput.value = plan.id
        }
      }
    }    
  }

  customElements.define('ia-product-buy', IaProductBuy)
}
